<swiper
  [centeredSlides]="true"
  [loop]="true"
  [slidesPerView]="1"
  [autoplay]="{
    delay: 2500,
    disableOnInteraction: false
  }"
  [pagination]="{
    clickable: true
  }"
  [navigation]="true"
  class="mySwiper"
>
  <ng-template swiperSlide
    ><img class="banner_img" src="assets/images/1621441682_iw.jpg" alt=""
  /></ng-template>
  <ng-template swiperSlide
    ><img
      class="banner_img"
      src="assets/images/1622550434_dairy_delights_web_main.jpg"
      alt=""
  /></ng-template>
  <ng-template swiperSlide
    ><img
      class="banner_img"
      src="assets/images/1623269698_summer_theme_web_main.jpg"
      alt=""
  /></ng-template>
</swiper>
